"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var exports_1 = require("@shared/constants/exports");
var translations_1 = require("@shared/constants/translations");
var common_1 = require("./services/dynamic-translation/common");
/*globals window:false*/
angular_1.module('qualtrics.pr', [
    'research-suite-wrapper',
    'qstrap',
    'ripsaw',
    'ripsaw.widgets',
    'ngRoute',
    'ngSanitize',
    'pascalprecht.translate',
    'qualtrics-rum',
    'filters-client',
    'cp.folderselector',
    'tractive',
    'tmh.dynamicLocale'
]);
(function (angularModule) {
    angularModule
        .config([
        '$compileProvider',
        '$routeProvider',
        '$locationProvider',
        '$translateProvider',
        'rsw.userServiceProvider',
        'rumProvider',
        '$httpProvider',
        'pr.REPORT_TYPES',
        'prQueryString',
        'routeTypes',
        'rsConfigProvider',
        'tmhDynamicLocaleProvider',
        function ($compileProvider, $routeProvider, $locationProvider, $translateProvider, userServiceProvider, rum, $httpProvider, REPORT_TYPES, qs, routeTypes, rsConfigProvider, tmhDynamicLocaleProvider) {
            rum.conf({ id: 'qualtrics.pr', appStats: true });
            $compileProvider.debugInfoEnabled(true); // set to false for production mode
            userServiceProvider.setUser(window.Qualtrics.Environment.user);
            initTranslations($translateProvider, tmhDynamicLocaleProvider, window.Qualtrics.Environment);
            setupRouteProvider($routeProvider, REPORT_TYPES, qs);
            $locationProvider.html5Mode({
                rewriteLinks: false,
                enabled: true,
                requireBase: false
            });
            $httpProvider.interceptors.push('pr.httpInterceptor');
            // set up routes for ripsaw client
            var config = {};
            config[routeTypes.CONTAINERS] = '/reports/ripsaw/containers';
            config[routeTypes.FIELDSETS] = '/reports/ripsaw/v2/fieldsets';
            var reportType = window.Qualtrics.Environment.reportType;
            config[routeTypes.REGISTRY] = '/reports/' + reportType + '/ripsaw/v2/registry';
            config[routeTypes.BENCHMARKS] = '/reports/' + reportType + '/benchmarks';
            rsConfigProvider.init(config);
        }
    ]);
    function getContainerId() {
        return lodash_1.default.get(window, 'Qualtrics.Environment.container.definition._id');
    }
    function getContainerDef() {
        return lodash_1.default.get(window, 'Qualtrics.Environment.container.definition');
    }
    var initTranslations = function ($translateProvider, tmhDynamicLocaleProvider, env) {
        $translateProvider.useSanitizeValueStrategy('escapeParameters');
        $translateProvider.uniformLanguageTag('bcp47');
        var lang = common_1.getUserLanguage(env.user);
        // Do not set any language if the user sets language as 'developer' (the settings is hidden in ControlPanel).
        // This will force angular-translate to show translation IDs
        if (lang === 'DEV') {
            return;
        }
        tmhDynamicLocaleProvider.localeLocationPattern('/reports/static/translations/i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.defaultLocale(common_1.getAngularLocale(lang));
        var messages = env.messages || {};
        var isEnabled = env.dynamicTranslations;
        if (isEnabled) {
            $translateProvider.useLoader('prStaticTranslationLoader');
        }
        $translateProvider.translations(lang, messages[lang] || {});
        $translateProvider.preferredLanguage(lang);
        if (lang !== translations_1.DEFAULT_LANGUAGE_CODE) {
            $translateProvider.translations(translations_1.DEFAULT_LANGUAGE_CODE, messages[translations_1.DEFAULT_LANGUAGE_CODE] || {});
            $translateProvider.fallbackLanguage(translations_1.DEFAULT_LANGUAGE_CODE);
        }
        return;
    };
    var setupRouteProvider = function ($routeProvider, REPORT_TYPES, qs) {
        /**
         * Takes in a path that does not include a report type
         * and sets the report type to RC
         *
         * @param {object} _params - unused
         * @param {string} currentPath - misconfigured path
         * @returns {string} fixed path that includes 'RC' as report type
         */
        var redirectToRC = function (_params, currentPath, search) {
            var pathArray = currentPath.split('/');
            if (lodash_1.default.includes(['view', 'public'], pathArray[2])) {
                // e.g. change /reports/view/:surveyId/.. to /reports/RC/view/:surveyId/..
                // insert report type without overwriting anything
                pathArray.splice(2, 0, 'RC');
            }
            else if (lodash_1.default.includes(['view', 'public'], pathArray[3])) {
                // e.g. change /reports/asdfg/:surveyId/.. to /reports/RC/view/:surveyId/..
                // overwrite existing report type
                pathArray.splice(2, 1, 'RC');
            }
            else {
                // path is completely messed up somehow
                return;
            }
            return qs.append(pathArray.join('/'), search);
        };
        var routerProviderConfigs = [
            {
                path: 'view/:trailing*',
                redirectTo: redirectToRC
            },
            {
                path: 'public/:trailing*',
                redirectTo: redirectToRC
            },
            {
                path: ':reportType/view/:surveyId',
                redirectTo: function (params, currentPath, search) {
                    if (!lodash_1.default.includes(REPORT_TYPES, params.reportType)) {
                        return redirectToRC(params, currentPath, search);
                    }
                    var envSurveyId = window.Qualtrics.Environment.activeSurveyId;
                    if (envSurveyId && envSurveyId !== params.surveyId) {
                        // replace the survey in path with survey on environment
                        return qs.append(currentPath.split('/').slice(0, -1).join('/') + '/' + envSurveyId, search);
                    }
                    var containerId = getContainerId();
                    if (containerId) {
                        return qs.append(currentPath + '/' + containerId, search);
                    }
                    return undefined; // explicitly returning undefined will continue this route
                },
                template: '<pr-no-reports></pr-no-reports>'
            },
            {
                path: ':reportType/view/:surveyId/:containerId',
                redirectTo: function (params, currentPath, search) {
                    if (!lodash_1.default.includes(REPORT_TYPES, params.reportType)) {
                        return redirectToRC(params, currentPath, search);
                    }
                    var containerId = getContainerId();
                    var dashboardId = lodash_1.default.get(getContainerDef(), 'contextMeta.dashboard.containerId');
                    if (!containerId) {
                        // remove container Id from path
                        return qs.append(currentPath.split('/').slice(0, -1).join('/'), search);
                    }
                    else if (containerId !== params.containerId) {
                        // set container id correctly
                        return qs.append(currentPath.split('/').slice(0, -1).join('/') + '/' + containerId, search);
                    }
                    else if (dashboardId !== search.dashboardId) {
                        // set dashboard Id correctly
                        search.dashboardId = dashboardId;
                        return qs.append(currentPath, search);
                    }
                    else {
                        return undefined;
                    }
                },
                template: '<pr-main></pr-main>'
            },
            {
                path: ':reportType/public/:publicHash',
                template: '<pr-main is-public="true"></pr-main>'
            },
            {
                path: ':reportType/view/:surveyId/:containerId/widget/:widgetId',
                template: '<pr-single-widget></pr-single-widget>'
            }
        ];
        var REPORT_PATH_PREFIXES = [exports_1.EXPORTS_URL_PREFIX, '/reports'];
        // Construct path prefixes for view/edit and export report views
        // & redirects.
        REPORT_PATH_PREFIXES.forEach(function (pathPrefix) {
            routerProviderConfigs.forEach(function (routerProviderConfig) {
                $routeProvider.when(pathPrefix + "/" + routerProviderConfig.path, {
                    redirectTo: routerProviderConfig.redirectTo,
                    template: routerProviderConfig.template
                });
            });
        });
    };
})(angular_1.module('qualtrics.pr'));
